module.exports = __webpack_public_path__ + "img/组1074.4dd49669.png";